import Axios, { Cancel, CancelToken, CancelTokenSource } from 'axios';

export default class CancelTokenManager {

  constructor(private controller: AbortController = new AbortController()) {}

  public getSignal(): AbortSignal {
    return this.controller.signal;
  }
  public resetSource(): void {
    this.controller = new AbortController();
  }
  public cancel(resetSource: boolean = true): void {
    this.controller.abort();
    if (resetSource) {
      this.resetSource();
    }
  }
}
export const GlobalTokenManager = new CancelTokenManager();
